/**
 * @class SetSwiper
 * use jquery
 */
import Swiper from 'swiper';
export default class SetSwiper {
  /**
   * constructor
   */
  constructor() {
    this.setup();
  }

  /**
   * setup
   */
  setup() {
    this.indexKv();
    this.topPj();
    this.other();
  }

  /**
   * indexKv
   * top メインスライド
   */
  indexKv() {
    var swiperIndex = new Swiper('.opj-parts__top--slide .swiper-container', {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
      speed: 800,
      effect: 'fade',
      on: {
        resize: function () {
          setTimeout(() => {
            this.update();
            // console.log(this)
          }, 2000);
        }
      }
    });
  }

  /**
   * topPj
   * top 下層記事スライド
   */
  topPj() {
    var swiperStories = new Swiper('.opj-stories .swiper-container', {
      // loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      navigation: {
        nextEl: '.opj-stories .swiper-button-next',
        prevEl: '.opj-stories .swiper-button-prev',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        768: {
          // loop: false,
          slidesPerView: 'auto',
          centeredSlides: false,
        }
      },
    });
    var swiperSchool = new Swiper('.opj-school .swiper-container', {
      // loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      navigation: {
        nextEl: '.opj-school .swiper-button-next',
        prevEl: '.opj-school .swiper-button-prev',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        768: {
          // loop: false,
          slidesPerView: 'auto',
          centeredSlides: false,
        }
      },
    });
  }

  /**
   * other
   * その他授業記事スライド
   */
  other() {
    var swiperOther = new Swiper('.opj-parts__slide1 .swiper-container', {
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        768: {
          loop: false,
          slidesPerView: 'auto',
          centeredSlides: false,
        }
      },
    });
  }
}